import { internal, template } from '../../../vendor/elix.js';

function ButtonContainedMixin(Base) {

  return class ButtonContained extends Base {

      get [internal.template]() {

        return template.concat(

          super[internal.template],

          template.html`
            <style>

              #inner {
                background-color: var(--tp-button-contained-mixin-background-color);
              }

              #inner[disabled], #inner:disabled {
                color: var(--tp-button-contained-mixin-font-color-disabled);
                background-color: var(--tp-button-contained-mixin-background-color-disabled);
              }
      
              #inner:hover:enabled {
                background-color: var(--tp-button-contained-mixin-background-color-hover);
              }
    
              :host(:focus) #inner:enabled,
              #inner:active:enabled {
                background-color: var(--tp-button-contained-mixin-background-color-active);
              }
            </style>
          `
        );
      }
    }
  }

export default ButtonContainedMixin;
